"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/* eslint-disable sonarjs/no-duplicated-branches */
function calculateTextSize(size, theme) {
  switch (size) {
    case 1:
      return {
        sm: theme.typography.paragraph[1].fontMobile,
        md: theme.typography.paragraph[1].fontTablet,
        lg: theme.typography.paragraph[1].fontDesktop,
        xl: theme.typography.paragraph[1].fontDesktop
      };

    case 2:
      return {
        sm: theme.typography.paragraph[1].fontMobile,
        md: theme.typography.paragraph[1].fontTablet,
        lg: theme.typography.paragraph[1].fontDesktop,
        xl: theme.typography.paragraph[1].fontDesktop
      };

    case 3:
      return {
        sm: theme.typography.heading[2].fontMobile,
        md: theme.typography.heading[1].fontTablet,
        lg: theme.typography.heading[1].fontDesktop,
        xl: theme.typography.heading[1].fontDesktop
      };

    case 4:
      return {
        sm: theme.typography.heading[4].fontMobile,
        md: theme.typography.heading[2].fontTablet,
        lg: theme.typography.heading[2].fontDesktop,
        xl: theme.typography.heading[2].fontDesktop
      };

    case 5:
      return {
        sm: theme.typography.heading[5].fontMobile,
        md: theme.typography.heading[4].fontTablet,
        lg: theme.typography.heading[3].fontDesktop,
        xl: theme.typography.heading[3].fontDesktop
      };

    case 6:
      return {
        sm: theme.typography.heading[5].fontMobile,
        md: theme.typography.heading[4].fontTablet,
        lg: theme.typography.heading[3].fontDesktop,
        xl: theme.typography.heading[3].fontDesktop
      };

    default:
      return {
        sm: '',
        md: '',
        lg: '',
        xl: ''
      };
  }
}

var _default = calculateTextSize;
exports["default"] = _default;
//# sourceMappingURL=calculateTextSize.js.map